import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import solvennLogoNavy from "@/assets/solvenn-navy.png.asset.json";
import solvennLogoWhite from "@/assets/solvenn-white.png.asset.json";

interface SolvennLogoProps {
  /** Force a variant regardless of the active theme (useful over dark surfaces). */
  variant?: "auto" | "inverse" | "light" | "dark";
  className?: string;
}

/** Official SOLVENN lockup: navy on light surfaces, white on dark surfaces. */
export function SolvennLogo({ variant = "auto", className = "h-10 w-auto" }: SolvennLogoProps): JSX.Element {
  const { resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const isDarkTheme = mounted && resolvedTheme === "dark";
  // "inverse" is for .section-band-alt, which is dark in light theme and light in dark theme.
  const isDarkSurface =
    variant === "dark" || (variant === "auto" && isDarkTheme) || (variant === "inverse" && (!mounted || !isDarkTheme));
  const src = isDarkSurface ? solvennLogoWhite.url : solvennLogoNavy.url;

  return <img src={src} alt="SOLVENN" className={`object-contain object-left ${className}`} decoding="async" />;
}

export default SolvennLogo;
